<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="编辑转账审核"
      width="500"
      :open="open"
      @close="close"
      class="update-dialog"
    >
      <mu-form :model="editForm" label-position="left" label-width="100">
        <mu-form-item prop="verifier" label="审核人">
          <mu-text-field v-model="editForm.verifier"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="verifyTime" label="审核时间">
          <mu-text-field v-model="editForm.verifyTime"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="isVerified" label="是否通过">
          <mu-text-field v-model="editForm.isVerified"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="remark" label="备注">
          <mu-text-field v-model="editForm.remark"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      editForm: {}
    }
  },
  methods: {
    submit() {
      backend(api.transferverify.update, this.editForm).then((result) => {
        if (result.statusCode === 200) {
          this.close()
          this.$emit('finish')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.editForm = JSON.parse(JSON.stringify(this.form))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.update-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/transferVerify/update.vue